import React from 'react'
import { Col, Row, Button, Card, CardBody } from 'reactstrap'
import { withFirebase } from '../../components/Fb'
import FalconModal from '../../components/Inputs/FalconModal'
import Infobox from '../../components/Infos/Infobox'
import moment from 'moment-timezone'
import 'moment/locale/fi'

import {
  getMessagingListSchema,
  getMessagingListUISchema,
} from '../../components/Inputs/dataschemas'
import { CircularProgress, Typography } from '@mui/material'
import { withAuthentication } from '../../components/Session'
import { DEFAULT_SPORTS, DEFAULT_TYPES } from '../../sports'

const PERIOD_TRANSLATIONS = {
  'last7days': 'Viimeiset 7 päivää',
  'last30days':'Viimeiset 30 päivää',
  'last90days':'Viimeiset 90 päivää',
  'lastmonth': 'Edellinen kalenterikuukausi',
  'thismonth': 'Tämä kalenterikuukausi',
  'lastyear': 'Edellinen kalenterivuosi',
  'thisyear': 'Tämä kalenterivuosi',
  'last365days': 'Viimeiset 365 päivää',
  'yeartodate': 'Kuluvan vuoden alusta tähän päähän',
  'custom': 'Mukautettu aikaväli',
}

const SOURCETYPE_TRANSLATIONS = {
  'reservations': 'Varaukset',
  'activities': 'Aktiviteetit',
  'memberships': 'Jäsenyydet',
  'eventtickets': 'Tapahtumaliput',
  'benefitcards': 'Sarjakortit',
  'users': 'Käyttäjät',
}

const RESERVATION_TYPE_TRANSLATIONS = {
  'single': 'Irtovuoro',
  'recurring': 'Vakiovuoro',
}

const RESERVATION_STATUS_TRANSLATIONS = {
  "reserved": "Varattu",
  "cancelled": "Peruttu",
  "onsale": "Myynnissä"
}

const BENEFITCARD_STATUSES = {
  "started": "Alkanut",
  "active": "Aktiivinen",
  "validuntil": "Voimassaolo asti",
}

function UpdateDate({ lastprocessed }) {
  if (lastprocessed) {
    return (moment(lastprocessed.toDate()).tz('Europe/Helsinki').format('D.M.YY HH:mm'))
  } else {
    return ('Listaa ei ole vielä haettu')
  }
}

function ListDetails({ item }) {
  if (item.sourcetype === 'reservations') {
    return (
      <Row>
        <Col xs={6}>
          <Typography variant='h6'>
            {item.period ? PERIOD_TRANSLATIONS[item.period] : 'Ei määritelty'}
          </Typography>
          {item.period === 'custom' ? (
            <Typography variant='h6'>
              {' '}
              ({moment(item.startdate).format('D.M.YY')} - {moment(item.enddate).format('D.M.YY')})
            </Typography>
          ) : null}
        </Col>
        {item.result ? (
          <Col xs={6} className='text-right'>
              <Typography variant='h3'>
                {item.result.count || 0}
              </Typography>
            <Typography variant='caption'>
              osoitetta listalla
              </Typography>
            </Col>
        ) : null}

        <Col xs={12}>
          <Typography variant='caption'>
            Lähde: {SOURCETYPE_TRANSLATIONS[item.sourcetype] || item.sourcetype}
          </Typography>
        </Col>
        <Col>
          <Typography variant='caption'>
            Varaustyypit: {item.reservationtype && item.reservationtype.length > 0
              ? item.reservationtype.map((t) => RESERVATION_TYPE_TRANSLATIONS[t]).join(', ')
              : 'Kaikki'}
          </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Varauksien tilat:{' '}
              {item.reservationstatus && item.reservationstatus.length > 0
                ? item.reservationstatus.map((s) => RESERVATION_STATUS_TRANSLATIONS[s]).join(', ')
                : 'Kaikki'}
          </Typography>
        </Col>
        {item.categories && item.categories.length > 0 ? (
          <Col xs={12}>
            <Typography variant='caption'>
              Kategoriat: {item.categories.join(', ')}
            </Typography>
          </Col>
        ) : null}
        {item.resources && item.resources.length > 0 ? (
          <Col xs={12}>
            <Typography variant='caption'>
              Resursseja valittuna: {item.resources.length}
            </Typography>
          </Col>
        ) : null}
        <Col xs={12}>
          <Typography variant='caption'>
            Päivitetty: <UpdateDate lastprocessed={item.lastprocessed} />
          </Typography>
        </Col>
        {item.result ? (
            <Col xs={12}>
              <Typography variant='caption'>
                <a href={item.result.url} target="_blank" rel="noreferrer">Lataa lista</a>
              </Typography>
            </Col>
        ) : null}
      </Row>
    )
  } else if (item.sourcetype === 'activities') {
    return (
      <Row>
        <Col xs={6}>
          <Typography variant='h6'>
            {item.period ? PERIOD_TRANSLATIONS[item.period] : 'Ei määritelty'}
          </Typography>
          {item.period === 'custom' ? (
            <Typography variant='h6'>
              {' '}
              ({moment(item.startdate).format('D.M.YY')} - {moment(item.enddate).format('D.M.YY')})
            </Typography>
          ) : null}
        </Col>
        {item.result ? (
          <Col xs={6} className='text-right'>
              <Typography variant='h3'>
                {item.result.count || 0}
              </Typography>
            <Typography variant='caption'>
              osoitetta listalla
              </Typography>
            </Col>
        ) : null}
        <Col xs={12}>
          <Typography variant='caption'>
            Lähde: {SOURCETYPE_TRANSLATIONS[item.sourcetype] || item.sourcetype}
          </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Aktiviteetti tyypit: {item.activitytype && item.activitytype.length > 0
              ? item.activitytype.map(t => DEFAULT_TYPES.find(d => d.key === t).label).join(', ')
              : 'Kaikki'}
          </Typography>
        </Col>
          <Col xs={12}>
            <Typography variant='caption'>
              Lajit: {item.activitysport && item.activitysport.length > 0
                ? item.activitysport.map((s) => DEFAULT_SPORTS.find((d) => d.key === s).label).join(', ')
                : 'Kaikki'}
            </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Päivitetty: <UpdateDate lastprocessed={item.lastprocessed} />
          </Typography>
        </Col>
        {item.result ? (
            <Col xs={12}>
              <Typography variant='caption'>
                <a href={item.result.url} target="_blank" rel="noreferrer">Lataa lista</a>
              </Typography>
            </Col>
        ) : null}
      </Row>
    )
  } else if (item.sourcetype === 'users') {
    return (
      <Row>
        {item.result ? (
          <Col xs={12} className='text-right'>
              <Typography variant='h3'>
                {item.result.count || 0}
              </Typography>
            <Typography variant='caption'>
              osoitetta listalla
              </Typography>
            </Col>
        ) : null}
        <Col xs={12}>
          <Typography variant='caption'>
            Lähde: {SOURCETYPE_TRANSLATIONS[item.sourcetype] || item.sourcetype}
          </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Päivitetty: <UpdateDate lastprocessed={item.lastprocessed} />
          </Typography>
        </Col>
        {item.result ? (
            <Col xs={12}>
              <Typography variant='caption'>
                <a href={item.result.url} target="_blank" rel="noreferrer">Lataa lista</a>
              </Typography>
            </Col>

        ) : null}
      </Row>
    )
  } else if (item.sourcetype === 'memberships') {
    return (
      <Row>
        <Col xs={6}>
          <Typography variant='h6'>
            {item.period ? PERIOD_TRANSLATIONS[item.period] : 'Ei määritelty'}
          </Typography>
          {item.period === 'custom' ? (
            <Typography variant='h6'>
              {' '}
              ({moment(item.startdate).format('D.M.YY')} - {moment(item.enddate).format('D.M.YY')})
            </Typography>
          ) : null}
        </Col>
        {item.result ? (
          <Col xs={6} className='text-right'>
              <Typography variant='h3'>
                {item.result.count || 0}
              </Typography>
            <Typography variant='caption'>
              osoitetta listalla
              </Typography>
            </Col>
        ) : null}
        <Col xs={12}>
          <Typography variant='caption'>
            Lähde: {SOURCETYPE_TRANSLATIONS[item.sourcetype] || item.sourcetype}
          </Typography>
        </Col>
        {/* <Col xs={12}>
          <Typography variant='caption'>
            Aktiviteetti tyypit: {item.activitytype && item.activitytype.length > 0
              ? item.activitytype.map(t => DEFAULT_TYPES.find(d => d.key === t).label).join(', ')
              : 'Kaikki'}
          </Typography>
        </Col>
          <Col xs={12}>
            <Typography variant='caption'>
              Lajit: {item.activitysport && item.activitysport.length > 0
                ? item.activitysport.map((s) => DEFAULT_SPORTS.find((d) => d.key === s).label).join(', ')
                : 'Kaikki'}
            </Typography>
        </Col> */}
        <Col xs={12}>
          <Typography variant='caption'>
            Päivitetty: <UpdateDate lastprocessed={item.lastprocessed} />
          </Typography>
        </Col>
        {item.result ? (
            <Col xs={12}>
              <Typography variant='caption'>
                <a href={item.result.url} target="_blank" rel="noreferrer">Lataa lista</a>
              </Typography>
            </Col>
        ) : null}
      </Row>
    )
  } else if (item.sourcetype === 'benefitcards') {
    return (
      <Row>
        <Col xs={6}>
          <Typography variant='h6'>
            {item.period ? PERIOD_TRANSLATIONS[item.period] : 'Ei määritelty'}
          </Typography>
          {item.period === 'custom' ? (
            <Typography variant='h6'>
              {' '}
              ({moment(item.startdate).format('D.M.YY')} - {moment(item.enddate).format('D.M.YY')})
            </Typography>
          ) : null}
        </Col>
        {item.result ? (
          <Col xs={6} className='text-right'>
              <Typography variant='h3'>
                {item.result.count || 0}
              </Typography>
            <Typography variant='caption'>
              osoitetta listalla
              </Typography>
            </Col>
        ) : null}
        <Col xs={12}>
          <Typography variant='caption'>
            Lähde: {SOURCETYPE_TRANSLATIONS[item.sourcetype] || item.sourcetype}
          </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Kortin tila: {item.benefitcardstatus && item.benefitcardstatus.length > 0
              ? item.benefitcardstatus.map(t => BENEFITCARD_STATUSES[t]).join(', ')
              : 'Kaikki'}
          </Typography>
        </Col>
          <Col xs={12}>
            <Typography variant='caption'>
              Lajit: {item.activitysport && item.activitysport.length > 0
                ? item.activitysport.map((s) => DEFAULT_SPORTS.find((d) => d.key === s).label).join(', ')
                : 'Kaikki'}
            </Typography>
        </Col>
        <Col xs={12}>
          <Typography variant='caption'>
            Päivitetty: <UpdateDate lastprocessed={item.lastprocessed} />
          </Typography>
        </Col>
        {item.result ? (
            <Col xs={12}>
              <Typography variant='caption'>
                <a href={item.result.url} target="_blank" rel="noreferrer">Lataa lista</a>
              </Typography>
            </Col>
        ) : null}
      </Row>
    )
  }
  return null
}

function MessageListListItem({
  item,
  processing,
  onEdit,
  onDelete,
  onFetch,
  result,
  disabled,
}) {
  console.log('messaging list item', item)
  let isProsessedUnder24h = false
  if (item.lastprocessed && item.lastprocessed.toDate) {
    isProsessedUnder24h = moment().diff(moment(item.lastprocessed.toDate()), 'hours') < 24
  } else if (item.lastprocessed && item.lastprocessed.seconds) {
    isProsessedUnder24h = moment().diff(moment.unix(item.lastprocessed.seconds), 'hours') < 24
  }
  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </Col>
          <Col className='text-right'>
            <Button
              disabled={processing || disabled}
              onClick={(e) => onEdit(item.id)}
              size='sm'
            >
              {/*
                            onClick={this.toggleMessagingListModal}
                              */}
              Muokkaa
            </Button>
            <Button
              disabled={processing || disabled}
              color='danger'
              onClick={(e) => onDelete(item.id)}
              size='sm'
            >
              {/* this.props.firebase
                                .deleteMessagingList(this.state.selectedList.id)
                                .then(() => {
                                  this.setState(
                                    { selectedListId: null, selectedList: {} },
                                    this.updateLists
                                  )
                                })
                            }
                          > */}
              Poista lista
            </Button>
          </Col>
        </Row>
        <ListDetails item={item} />
        {!isProsessedUnder24h ? (
        <Row>
          <Col>
            <Button
              disabled={processing || disabled}
              color='success'
              onClick={(e) => onFetch(item.id)}
            >Päivitä lista
            </Button>
          </Col>
        </Row>
        ) : null}
        <Row>
          <Col className='text-center'>
            {processing ? (
              <div>
                <CircularProgress />
                <Typography component='p' variant='caption'>
                  Aikavälin pituudesta riippuen prosessointi voi kestää useita
                  minuutteja
                </Typography>
              </div>
            ) : result && result.count ? (
                <div>
                <Typography component='p' variant='subtitle2'>
                  {result && result.count} jäsentä haettu{' '}
                </Typography>
                <a href={result && result.url}>Lataa lista</a>
              </div>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

class MessagingListsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      lists: [],
      selectedListId: null,
      selectedList: {},
      messagingListModalOpen: false,
      listOptions: [],
      processing: false,
      result: {},
      resources: [],
      categories: [],
    }
  }

  filterData = () => {
    if (this.state.lists) {
      let _listOptions = this.state.lists.map((p) => {
        return {
          value: p.id,
          label: p.name,
          active: p.active,
        }
      })
      this.setState({ listOptions: _listOptions, loading: false })
    } else {
      this.setState({ loading: false })
    }
    console.log('messaging lists after filter', this.state.categories)
  }

  updateLists = async () => {
    Promise.all([
      this.props.firebase.getMessagingLists(),
      this.props.firebase.getResourceCategories().get(),
      this.props.firebase.getMemberships(),
    ]).then((values) => {
      let messaginglists = values[0]
      let memberships = []
      if (!values[2].empty) {
        memberships = values[2].docs.map((d) => {
          return { id: d.id, ...d.data() }
        })
      }
      let categories = []
      if (values[1] && values[1].data()) {
        categories = values[1].data().categories
      }
      this.setState(
        {
          lists: messaginglists,
          categories,
          memberships: memberships,
        },
        this.filterData
      )
    })
  }

  componentDidMount() {
    this.updateLists()
  }

  toggleMessagingListModal = (state) => {
    if (state === 'new') {
      this.setState({
        selectedList: {},
        selectedListId: null,
        messagingListModalOpen: !this.state.messagingListModalOpen,
      })
    } else if (this.state.selectedListId) {
      let _selectedList = this.state.lists.find(
        (p) => p.id === this.state.selectedListId
      )
      if (_selectedList) {
        this.setState({
          selectedList: _selectedList,
          messagingListModalOpen: !this.state.messagingListModalOpen,
        })
      }
    } else {
      this.setState({
        messagingListModalOpen: !this.state.messagingListModalOpen,
      })
    }
  }

  updateViewableList = (id) => {
    const _selectedList = this.state.lists.find((p) => p.id === id)
    if (_selectedList) {
      this.setState({
        selectedListId: _selectedList.id,
        selectedList: _selectedList,
      })
    }
  }

  selectList = (event) => {
    if (event === null) {
      this.setState({ selectedListId: null, selectedList: {} })
      return
    }
    this.updateViewableList(event.value)
    // if (this.filterRef && this.filterRef.current) {
    //   console.log(window.innerHeight, this.filterRef.current.clientHeight)
    //   let calendarSpace = Math.round(
    //     ((window.innerHeight - this.filterRef.current.clientHeight - 150)/ window.innerHeight) * 100
    //   )
    //   calendarSpace = calendarSpace > 80 ? 80 : calendarSpace
    //   this.setState({ calendarHeight: calendarSpace + 'vh' })
    // }
  }

  getSchema = () => {
    const schema = getMessagingListSchema()
    const resourceOneOf = this.props.customerdata.resources
      .sort((a, b) => a.displayName.localeCompare(b.displayName))
      .map((res) => ({ const: res.id, title: res.displayName }))
    schema.dependencies.sourcetype.oneOf.forEach((s) => {
      if (s.properties && s.properties.resources) {
        s.properties.resources.items = { type: 'string', oneOf: resourceOneOf }
      }
      if (s.properties && s.properties.categories) {
        const catOneOf = this.state.categories.sort().map((cat) => ({
          const: cat.category.toLowerCase(),
          title: cat.category,
        }))
        s.properties.categories.items = { type: 'string', oneOf: catOneOf }
      }
      if (s.properties && s.properties.membershipids && this.state.memberships) {
        const membershipOneOf = this.state.memberships.map((mem) => {
          const name = mem.displayName ? mem.displayName : mem.name
          return {
            const: mem.id,
            title: mem.state === 'deleted' ? name + ' (poistettu)' : name,
          }
        })
        s.properties.membershipids.items = { type: 'string', oneOf: membershipOneOf }
      }
    })
    return schema
  }

  processFetch = () => {
    this.setState({ processing: true })
    this.props.firebase
      .fetchMessagingListMembers(this.state.selectedListId)
      .then((r) => {
        this.setState({ processing: false, result: {} }, this.updateLists)
      })
      .catch(() => {
        this.setState({ processing: false, result: {} }, this.updateLists)
      })
  }

  render() {
    if (!this.state.loading) {
      return (
        <>
          <div className='content' style={{ height: '75vh' }}>
            <Row>
              {/* <Col md='4'>
                <Card>
                  <CardBody>
                    <Select
                      disabled={this.state.processing}
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      closeMenuOnSelect={true}
                      name='resourcepricings'
                      options={this.state.listOptions}
                      // formatGroupLabel={formatGroupLabel}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      placeholder='Listat ...'
                      value={
                        this.state.selectedListId
                          ? this.state.listOptions.find(
                              (p) => p.value === this.state.selectedListId
                            )
                          : null
                      }
                      isClearable={true}
                      isSearchable={true}
                      onChange={this.selectList}
                      noOptionsMessage={() => 'Ei listoja'}
                    />
                  </CardBody>
                </Card>
              </Col> */}
              <Col>
                <Button
                  disabled={this.state.processing}
                  onClick={(e) => this.toggleMessagingListModal('new')}
                >
                  Lisää uusi lista
                </Button>
              </Col>
              <Col>
                <Infobox index={0} />
              </Col>
            </Row>
            <Row>
              <Col className='mb-2'>
              <Typography variant='caption'>
                Huom! Voit ladata listat käytettäväksi markkinointityökalussa tai omasta sähköpostista lähetystä varten. Listaa ei tarvitse erikseen päivittää tai ladata jos lähetät viestin järjestelmästä.
              </Typography>
              </Col>
            </Row>
            <Row>
              {this.state.lists.map((item) => (
                <Col xs='12' md='6' key={item.id} className='mb-3'>
                  <MessageListListItem
                    item={item}
                    result={this.state.result[item.id]}
                    processing={
                      this.state.processing &&
                      this.state.selectedListId === item.id
                    }
                    disabled={this.state.processing}
                    onEdit={(id) => {
                      this.setState(
                        {
                          selectedListId: id,
                        },
                        this.toggleMessagingListModal
                      )
                    }}
                    onDelete={(id) => {
                      this.props.firebase.deleteMessagingList(id).then(() => {
                        this.setState(
                          { selectedListId: null, selectedList: {} },
                          this.updateLists
                        )
                      })
                    }}
                    onFetch={(id) => {
                      this.setState({ selectedListId: id }, this.processFetch)
                    }}
                  />
                </Col>
              ))}
            </Row>
            {/* <Row>
              <Col>
                
                {this.state.selectedList && this.state.selectedList.id ? (
                  <Card>
                    <CardBody>
                      <Row>
                        <Col>
                          <h3>{this.state.selectedList.name}</h3>
                          <p>{this.state.selectedList.description}</p>
                        </Col>
                        <Col className='text-right'>
                          <Button
                            disabled={
                              !this.state.selectedListId ||
                              this.state.processing
                            }
                            onClick={this.toggleMessagingListModal}
                          >
                            Muokkaa
                          </Button>
                          <Button
                            disabled={
                              !this.state.selectedListId ||
                              this.state.processing
                            }
                            color='danger'
                            onClick={(e) =>
                              this.props.firebase
                                .deleteMessagingList(this.state.selectedList.id)
                                .then(() => {
                                  this.setState(
                                    { selectedListId: null, selectedList: {} },
                                    this.updateLists
                                  )
                                })
                            }
                          >
                            Poista lista
                          </Button>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Button
                            disabled={
                              !this.state.selectedListId ||
                              this.state.processing
                            }
                            color='success'
                            onClick={(e) => this.processFetch()}
                          >
                            Hae lista
                          </Button>
                        </Col>
                      </Row>
                      <Row>
                        <Col className='text-center'>
                          {this.state.processing ? (
                            <div>
                              <CircularProgress />
                              <Typography component='p' variant='caption'>
                                Aikavälin pituudesta riippuen prosessointi voi
                                kestää useita minuutteja
                              </Typography>
                            </div>
                          ) : this.state.result !== null ? (
                              <div>
                                <Typography component='p' variant='subtitle2' >
                              {this.state.result.count} jäsentä haettu{' '}</Typography>
                              <a href={this.state.result.url}>Lataa lista</a>
                            </div>
                          ) : (
                            'Erroria ei ole, mutta tuloksia ei ole myöskään haettu'
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ) : (
                  ''
                )}
              </Col> 
            </Row>*/}
            {/* <pre>{JSON.stringify(this.state.result, null, 2)}</pre>
            <pre>{JSON.stringify(this.state.selectedList, null, 2)}</pre> */}
            <FalconModal
              onCreate={this.props.firebase.createMessagingList}
              onUpdate={this.props.firebase.updateMessagingList}
              modifiedCallback={this.updateLists}
              toggle={this.toggleMessagingListModal}
              cancel={this.toggleMessagingListModal}
              resource={this.state.selectedList}
              isOpen={this.state.messagingListModalOpen}
              uiSchema={getMessagingListUISchema()}
              dataSchema={this.getSchema()}
              title={
                this.state.selectedList && this.state.selectedList.id
                  ? 'Muokkaa listaa'
                  : 'Uusi lista'
              }
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <Row>
            <Col>Loading ...</Col>
          </Row>
        </>
      )
    }
  }
}

export default withAuthentication(withFirebase(MessagingListsContainer))
